import { z } from 'zod';
import { vehicleDetailSchema } from '../../vehicles/schemas/vehicles.schemas.js';
import { estimateDetailSchema } from './estimates.schemas.js';
/**
 * The purchase's answer: **both** records, as they stand after the one transaction that created the
 * second one (plan §5.6).
 *
 * It lives in a file of its own because it is the single place where the estimate and the vehicle shapes
 * meet — putting it in either area's schema file would make the two import each other in a circle, which
 * is exactly the kind of coupling the phase boundary is meant to avoid.
 */
export const purchaseEstimateOutputSchema = z.object({
    estimate: estimateDetailSchema,
    vehicle: vehicleDetailSchema,
});
//# sourceMappingURL=purchase.schemas.js.map